interface EnvConfig {
  apiBaseUrl: string;
  appVersion: string;
  environment: 'development' | 'staging' | 'production';
  providers: {
    youtube: {
      apiKey: string;
      channelId: string;
      enabled: boolean;
    };
    googleAnalytics: {
      measurementId: string;
      enabled: boolean;
    };
  };
}

// Helper function to get required environment variables
const getRequiredEnvVar = (key: string): string => {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
};

// In development, we need to use the proxy
const getApiBaseUrl = () => {
  const environment = getRequiredEnvVar('VITE_ENVIRONMENT');
  const configuredUrl = getRequiredEnvVar('VITE_API_BASE_URL');
  
  // In development on web, use the proxy
  if (environment === 'development' && !import.meta.env.MODE.includes('android')) {
    // Extract just the /v1/organizations/xxx part from the full URL
    const urlPath = new URL(configuredUrl).pathname;
    return urlPath; // This will be like '/v1/organizations/xxx'
  }
  
  // In production or on Android, use the full URL
  return configuredUrl;
};

export const env: EnvConfig = {
  apiBaseUrl: getApiBaseUrl(),
  appVersion: getRequiredEnvVar('VITE_APP_VERSION'),
  environment: getRequiredEnvVar('VITE_ENVIRONMENT') as EnvConfig['environment'],
  providers: {
    youtube: {
      apiKey: getRequiredEnvVar('VITE_YOUTUBE_API_KEY'),
      channelId: getRequiredEnvVar('VITE_YOUTUBE_CHANNEL_ID'),
      enabled: true,
    },
    googleAnalytics: {
      measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || '',
      enabled: Boolean(import.meta.env.VITE_GA_MEASUREMENT_ID),
    },
  },
};

export const getEnvConfig = () => env;
